enum BiproxiProductEnum {
  DataExplorer = 'Data Explorer'
}

export default BiproxiProductEnum;
